// src/lazy/livekit.ts
import type { Room as LivekitRoom, RoomEvent } from 'livekit-client';

let livekit: typeof import('livekit-client') | null = null;

export async function getLiveKit() {
  if (!livekit) {
    livekit = await import('livekit-client');
  }
  return livekit;
}

// Preload LiveKit bundle ahead of time (on idle, hover, etc.)
export function preloadLiveKit() {
  // This will be cached by the browser if already loaded
  void import('livekit-client');
}

export type { LivekitRoom, RoomEvent };
